module.exports = __webpack_public_path__ + "static/img/model-bg23.44eaca2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg23.jpg
// module id = TUTa
// module chunks = 0